import Resource from './Resource'

class SpainAgreementCode extends Resource {
  static urlRoot() {
    return '/contracts/spain/agreement_codes'
  }
}

export default SpainAgreementCode
